import Button from '@atlaskit/button';
import CrossIcon from '@atlaskit/icon/core/migration/close--cross';
import {
  BrokenDatabase,
  Database,
  DatabaseField,
  EntryCreateOptions,
  EntryWithContext,
} from '@databases/types/database';
import React, { FunctionComponent } from 'react';
import { useIntl } from 'react-intl-next';

import { messages } from '../../i18n';
import EmbedReferencePicker from '../embedReferencePicker/EmbedReferencePicker';

import {
  FormHeaderContainer,
  FormTitle,
  ReferenceOptionsContainer,
} from './embedReferenceOptions.styles';

export interface EmbedReferenceOptionsProps {
  setSelectedDatabase: (value: Database | BrokenDatabase | undefined) => void;
  selectedDatabase: Database | BrokenDatabase | undefined;
  setSelectedEntry: (value: EntryWithContext | EntryCreateOptions | undefined) => void;
  selectedEntry: EntryWithContext | EntryCreateOptions | undefined;
  setSelectedField: (value: DatabaseField | undefined) => void;
  selectedField: DatabaseField | undefined;
  databaseError: boolean;
}

export const cancelDatabaseReference = () => {
  window.parent.postMessage(
    JSON.stringify({ cancelDatabaseReference: true }),
    window.location.origin
  );
};

const EmbedReferenceOptions: FunctionComponent<EmbedReferenceOptionsProps> = ({
  setSelectedDatabase,
  selectedDatabase,
  setSelectedEntry,
  selectedEntry,
  setSelectedField,
  selectedField,
  databaseError,
}) => {
  const { formatMessage } = useIntl();

  return (
    <ReferenceOptionsContainer>
      <FormHeaderContainer>
        <FormTitle>{formatMessage(messages['reference-picker.header'])}</FormTitle>
        <Button
          appearance="subtle"
          iconBefore={
            <CrossIcon label={formatMessage(messages['reference-picker.close'])} />
          }
          onClick={cancelDatabaseReference}
          testId={'reference-close-button'}
        />
      </FormHeaderContainer>
      <EmbedReferencePicker
        setSelectedDatabase={setSelectedDatabase}
        selectedDatabase={selectedDatabase}
        setSelectedEntry={setSelectedEntry}
        selectedEntry={selectedEntry}
        setSelectedField={setSelectedField}
        selectedField={selectedField}
        handleCancel={cancelDatabaseReference}
        databaseError={databaseError}
      />
    </ReferenceOptionsContainer>
  );
};

export default EmbedReferenceOptions;
